import styled from 'styled-components';
import rmq from 'styled-rmq';

export default styled.div`
	display: table;
	width: 100%;
	max-width: 75rem;
	margin: 0 auto;
	position: relative;
	/* overflow: hidden; */

	${rmq('t')} {
		padding: 0 6rem;
	}
	${rmq('700')} {
		padding: 0;
	}
	${rmq('485')} {
		padding: 0;
	}
	${rmq('ml')} {
		padding: 0;
	}
`;
